import { Appl } from '../../../core/Appl';
import { SpcService } from './SpcService';
import { NavItem } from '../../../core/services/Models';
import SpcViewModel from './calculator/SpcViewModel';

export default class SpcModule {

  public static MenuItems(): Array<NavItem> {

    let menuItems: Array<NavItem> = [];
    return menuItems
  }

  public static init(): void {
    Appl.Services.add('ISpcService', SpcService);
    Appl.Services.add('SpcViewModel', SpcViewModel);
  }
}
